import { Component, OnInit } from '@angular/core';
import { DictionaryUnitConverterService } from '../../../app/shared/services/dictionary-unit-converter-service';
import { DictionaryUnitConverterEntity } from '../../../app/shared';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/components/shared/confirmation-dialog/confirmation-dialog.component';
import { AddUnitConverterDialogComponent } from 'src/components/pages/dictionaries-unit-converter-tab/add-unit-converter-dialog/add-unit-converter-dialog.component';
import { DictionaryType } from '../../shared/dictionaries-layout';
import {
  CustomButtonDefinition,
  DataTableDataDefinition,
} from '../../../app/shared/fca-data-table';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorDialogComponent } from '../../shared/error-dialog/error-dialog.component';

@Component({
  selector: 'dictionary-unit-converter-tab',
  templateUrl: './unit-converter.component.html',
  styleUrls: ['./unit-converter.component.scss'],
})
export class DictionaryUnitConverterTab implements OnInit {
  data: DictionaryUnitConverterEntity[] | null = null;
  pageSize = 10;

  dataDefinition: DataTableDataDefinition<DictionaryUnitConverterEntity> = [
    {
      name: '',
      allowGroup: true,
      columns: [
        {
          fieldName: 'Unit',
          caption: 'Unit',
          valueType: 'text',
          editable: false,
          deletable: true,
        },
        {
          fieldName: 'Factor',
          caption: 'Factor',
          valueType: 'text',
          editable: false,
          deletable: false,
        },
      ],
    },
  ];

  constructor(
    private dataService: DictionaryUnitConverterService,
    public dialog: MatDialog
  ) {}

  title = 'Dictionary';
  dictionaryType = DictionaryType.UnitConverter;
  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.dataService.getAll().subscribe((receivedData) => {
      this.data = receivedData.map(item => ({
        ...item,
        Factor: item.Factor.toString().replace('.', ',') as any
      }));
    });
  }

  customButtons: CustomButtonDefinition<DictionaryUnitConverterEntity>[] = [
    {
      icon: 'delete_outline',
      hint: 'Delete row',
      onClick: this.confirmDelete.bind(this) as (x: any) => {},
    },
  ];

  isDialogOpen = false;

  addUnitConverter() {
    if (this.isDialogOpen) {
      return;
    }

    this.isDialogOpen = true;

    const dialogRef = this.dialog.open(AddUnitConverterDialogComponent, {
      width: '350px',
      panelClass: 'custom-dialog-container',
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      data: { unit: '', factor: '' },
    });

    dialogRef.componentInstance.onAddCallback = (unit: string, factor: number) => {
      this.dataService.add({ Unit: unit, Factor: factor, Id: undefined }).subscribe({
        next: () => {
          this.loadData();
          dialogRef.close();
        },
        error: (error: HttpErrorResponse) => {
          if (error.status === 409) {
            this.dialog.open(ErrorDialogComponent, {
              data: { message: 'This Unit already exists in the system.' },
            });
          }
        },
      });
    };

    dialogRef.afterClosed().subscribe(() => {
      this.isDialogOpen = false;
    });
  }

  confirmDelete(unitConverter: DictionaryUnitConverterEntity) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        title: 'Confirmation',
        message: 'Are you sure you want to remove this item?',
        buttons: {
          cancel: 'No',
          confirm: 'Yes',
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Yes') {
        this.dataService.delete(unitConverter).subscribe({
          next: () => {
            this.loadData();
          },
          error: (error: HttpErrorResponse) => {
            if (error.status === 400 || error.status === 409) {
              const message = (error.error?.Message || error.error?.message || 'This unit converter is currently used in the system.').replace(/\n/g, '<br>');
              this.dialog.open(ErrorDialogComponent, {
                width: '350px',
                data: {
                  title: 'Attention',
                  message: message
                },
              });
            }
          },
        });
      }
    });
  }
}

